import React, { useState, useEffect } from 'react';
import { Download, Check } from 'lucide-react';

function PWAInstallButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
      setIsInstalled(true);
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) {
      alert('Die Installation ist auf diesem Gerät nicht verfügbar. Öffne die App im Browser und nutze das Browser-Menü (⋮) > "Zum Startbildschirm hinzufügen".');
      return;
    }

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      console.log('User accepted the install prompt');
      setIsInstalled(true);
    }
    
    setDeferredPrompt(null);
  };

  if (isInstalled) {
    return (
      <div 
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '16px',
          background: 'rgba(74, 222, 128, 0.1)',
          border: '1px solid rgba(74, 222, 128, 0.3)',
          borderRadius: '12px',
          color: '#4ade80'
        }}
        data-testid="pwa-installed"
      >
        <Check size={24} />
        <span>✅ ZENTA ist bereits installiert!</span>
      </div>
    );
  }

  return (
    <button
      onClick={handleInstall}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '16px 24px',
        background: 'linear-gradient(135deg, rgba(194, 164, 90, 0.2) 0%, rgba(212, 183, 106, 0.15) 100%)',
        border: '1px solid rgba(194, 164, 90, 0.4)',
        borderRadius: '12px',
        color: '#c2a45a',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '16px',
        transition: 'all 0.2s',
        width: '100%',
        justifyContent: 'center'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'linear-gradient(135deg, rgba(194, 164, 90, 0.3) 0%, rgba(212, 183, 106, 0.2) 100%)';
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'linear-gradient(135deg, rgba(194, 164, 90, 0.2) 0%, rgba(212, 183, 106, 0.15) 100%)';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
      data-testid="pwa-install-button"
    >
      <Download size={20} />
      <span>ZENTA als App installieren</span>
    </button>
  );
}

export default PWAInstallButton;
